/**
 * All Pubsub implementations must use this symbol as the name of a property
 * with a boolean `true` value
 */
export const pubSubSymbol = Symbol.for('@libp2p/pubsub')
